import { render, staticRenderFns } from "./ImagePreviewModal.vue?vue&type=template&id=3247480d&scoped=true&"
import script from "./ImagePreviewModal.vue?vue&type=script&lang=js&"
export * from "./ImagePreviewModal.vue?vue&type=script&lang=js&"
import style0 from "./ImagePreviewModal.vue?vue&type=style&index=0&id=3247480d&lang=scss&scoped=true&"
import style1 from "./ImagePreviewModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3247480d",
  null
  
)

export default component.exports